<template>
	<div id="ScanBatches" class="usually-on-top">
		<div id="ScanStart" v-if="!isScanningParty" class="fullscreen-centered always-on-top dark-stars">
			<div>
				<Logo/>
				<div><h2 class="scanner-name">{{ scannerName }}</h2></div>
				<div class="scanner-users">
					<ul>
						<li v-for="user in scannerUsers" v-bind:key="user.id">
							<div class="user-thumbnail">
								<img class="user-image" v-bind:src="getUserImage(user.photo)" v-bind:alt="user.name" onerror="this.src='images/default_user.jpg'"/>
							</div>
							<h4 class="user-name">{{ user.name }}</h4>
						</li>
					</ul>
				</div>
				<div class="button-row"><button class="better-mobile-btn green" id="GetStarted" v-bind:disabled="disableNewPartyBtn" v-on:click="startBatch"><i class="fas fa-mobile-alt"></i> New Party</button></div>
				<div class="extraBtns"><button class="better-mobile-btn red" id="StartOver" v-on:click="unregister"><i class="fas fa-power-off"></i> Unregister Scanner</button></div>
			</div>
		</div>

		<ScanBatch
			v-if="isScanningParty && $scanner.partyId && !hasPartyPaid"
			v-bind:id="`scanbatch_${ this.$scanner.partyId }`"
			v-bind:key="this.$scanner.partyId"
			@unregister="emitUnregistered"
			@partyPaid="onPartyPaid"
		/>

		<ScanCredentials
			v-if="isScanningParty && $scanner.partyId && hasPartyPaid"
			@submitted="submittedParty(true)"
		/>

		<SubmittedParty v-if="showSubmittedParty" @done="submittedParty(false)"/>
	</div>
</template>

<script>
	import axios from 'axios';
	import ScanBatch from './ScanBatch.vue'
	import Logo from "@/components/Logo.vue";
	import ScanCredentials from "@/components/ScanCredentials.vue";
	import SubmittedParty from "@/components/SubmittedParty.vue";

	export default {
		name: 'ScanBatches',
		inject: ['rfidService'],
		components: {
			ScanCredentials,
			ScanBatch,
			Logo,
			SubmittedParty,
		},
		props: {
			hasActiveParty: Boolean,
		},
		data() {
			return {
				disableNewPartyBtn: false,
				isScanningParty: false,
				scannerUsers: [],
				hasPartyPaid: false,
				showSubmittedParty: false
			}
		},
		computed: {
			scannerName: function () { this.$scanner.title = localStorage.getItem('scanner_title'); return this.$scanner.title; },
		},
		beforeMount() {
			this.getAvailableDecals()
			this.getAvailableTickets().catch(() => alert('Unable to get available tickets for user'))
			this.getReentryFee()
			if(localStorage.getItem('party_id')) {
				this.$scanner.partyId = localStorage.getItem('party_id')
			}
		},
		mounted() {
			this.$scanner.startBatch = this.startBatch
			this.$scanner.cancelBatch = this.cancelBatch
			this.$scanner.closeBatch = this.closeBatch
			this.$scanner.loadUsers = this.loadScannerFromStorage
			this.$scanner.getAvailableTickets = this.getAvailableTickets
			this.loadScannerFromStorage()
			this.$scanner.partyId = this.$scanner.partyId ? this.$scanner.partyId : ''
			this.$scanner.partyPaid = false
			if(this.$scanner.partyId || this.hasActiveParty) {
				this.startBatch();
			}
			window.addEventListener('pagehide', this.disconnectRfidReader)
		},
		beforeDestroy() {
			window.removeEventListener('pagehide', this.disconnectRfidReader)
			this.disconnectRfidReader()
		},
		methods: {
			disconnectRfidReader() {
				this.rfidService.disconnectReader()
			},
			loadScannerFromStorage() {
				window.debug('🗄DataStore: 👤Loading Scanners from Storage')
				let users = [];
				let user_count = (localStorage.getItem('scanner_user_count')) ? localStorage.getItem('scanner_user_count') : 0;
				for (let i = 1; i <= user_count; ++i) {
					users.push({ id: localStorage.getItem(`scanner_user_0${i}_id`), name: localStorage.getItem(`scanner_user_0${i}_name`), photo: localStorage.getItem(`scanner_user_0${i}_photo`) })
				}
				this.scannerUsers = users
				window.debug(`🗄DataStore: 👤Users ${users.length}`)
			},
			getAvailableDecals() {
				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/availableDecals`, {
					check: scannerRegKey,
				})
				.then(res => {
					if (res.status === 200) {
						const data = res.data.data;
						this.$scanner.availableDecalsMap = {}
						data.forEach(decal => { this.$scanner.availableDecalsMap[decal.id] = decal });
					} else {
						alert('Unable to get available decals for user');
					}
				})
				.catch(err => {
					alert('Unable to get available decals for user');
					window.debug(err);
				});
			},
			getAvailableTickets() {
				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				/* NOTE: Returns the request promise (rather than swallowing errors here) so
				 * callers - namely PurchaseTicket/EnterUserInformation re-checking availability
				 * against concurrent gate AND ticket-portal sales - can tell a fresh fetch
				 * actually succeeded before trusting $scanner.availableTickets. */
				return axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/availableTickets`, {
					check: scannerRegKey,
				})
				.then(res => {
					if (res.status !== 200) {
						throw new Error('Unable to get available tickets for user');
					}
					this.$scanner.availableTickets = res.data.data
				})
			},
			getReentryFee() {
				const scannerRegKey = localStorage.getItem('scanner_regkey');
				axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
				axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/getReentryFee`, {
					check: scannerRegKey,
				})
				.then(res => {
					if (res.status === 200) {
						this.$scanner.reEntryFee = res.data
					} else {
						alert('Unable to get re-entry fee');
					}
				})
				.catch(err => {
					alert('Unable to get re-entry fee');
					window.debug(err);
				});
			},
			startBatch() {
				this.disableNewPartyBtn = true;
				const empty = window.helpers.empty;
				window.scanner.loader.open()

				const scannerRegKey = localStorage.getItem('scanner_regkey');
				if (!empty(scannerRegKey)) {
					axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
					axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/start`, {
						check: scannerRegKey,
					})
					.then(res => {
						if (res.data.status.success) {
							const data = res.data.data;
							this.$scanner.partyId = data.party_id
							this.hasPartyPaid = data.party_paid
							this.disableNewPartyBtn = false
							this.isScanningParty = true

							localStorage.setItem('party_id', data.party_id)
							window.scanner.loader.close()
						} else {
							alert('🚘Scan Party: 🚫Start Party Failed');
							window.debug(res.data.data);
							window.scanner.loader.close()
							this.disableNewPartyBtn = true
							this.isScanningParty = false
						}
					})
					.catch(err => {
						alert('🚘Scan Party: 🚫Error Connecting to Server for Scan Party Start');
						window.debug(err);
						window.scanner.loader.close()
						this.disableNewPartyBtn = true
						this.isScanningParty = false
					});
				} else {
					alert('🗄DataStore: 📱Scanner Not Found to Start Party');
				}
			},
			cancelBatch() {
				if (confirm('Close Party?')) {
					const empty = window.helpers.empty;
					this.disableNewPartyBtn = true;
					this.isScanningParty = false;

					window.scanner.loader.open()

					const scannerRegKey = localStorage.getItem('scanner_regkey');
					if (!empty(scannerRegKey)) {
						axios.defaults.headers.common['X-Auth-Token'] = scannerRegKey;
						axios.post(`${this.$scanner.api_server}/api/scannerdevice/party/cancel`, {
							check: scannerRegKey,
							party_id: `${this.$scanner.partyId}`,
						})
						.then(res => {
							if (res.data.status.success) {
								this.$scanner.partyId = ''
								this.disableNewPartyBtn = false
								this.isScanningParty = false
								localStorage.removeItem('party_id')
								window.scanner.loader.close()
							} else {
								alert('🚘Scan Party: 🚫Party Cancel Failed');
								location.reload();
							}
						})
						.catch(err => {
							alert('🚘Scan Party: 🚫Error Connecting to Server for Scan Party Cancel');
							window.debug(err);
							location.reload();
						});
					} else {
						window.debug('🗄DataStore: 📱Scanner Not Found to Start Party');
					}
				}
			},
			closeBatch() {
				this.$scanner.partyId = 0
				this.disableNewPartyBtn = false
				this.isScanningParty = false
				window.scanner.loader.close()
			},
			emitUnregistered() {
				this.$emit('unregister');
			},
			unregister() {
				if (!confirm("Reset this scanner to re-register?")) {
					return;
				}
				localStorage.clear();
				this.emitUnregistered();
				window.location.reload();
			},
			getUserImage(userImageStr) {
				return userImageStr ? `${window.scanner.api_server}/media/user/${(userImageStr)}` : '/images/default_user.jpg';
			},
			onPartyPaid() {
				this.hasPartyPaid = true
			},
			submittedParty(shouldShow) {
				this.showSubmittedParty = shouldShow
			}
		}
	}
</script>

<style>
	.dark-stars h2.scanner-name { text-transform: uppercase; color: var(--color-red); }
	.scanner-users { padding: 40px 20px; }
	.scanner-users ul { margin: 0px; padding: 0px; list-style: none; display: inline-block; }
	.scanner-users li { margin: 0px; padding: 5px 10px; list-style: none; display: inline-block; text-align: left; }
	.scanner-users .user-thumbnail { position: relative; display: inline-block; vertical-align: middle; height: 45px; width: 45px; border-radius: 23px; border: 2px solid #fff; overflow: hidden; margin-right: 15px; }
	.scanner-users .user-thumbnail img { object-fit: cover; min-width: 100%; min-height: 100%; }
	.scanner-users .user-name { margin: 0px; padding: 8px 0px 0px; display: inline-block; vertical-align: middle; font-size: 24px; letter-spacing: 1px; }
	.extraBtns {display: flex; justify-content: space-evenly; position: absolute; bottom: 1em; margin-left: auto; margin-right: auto; left: 0; right: 0;}
</style>
